import { Helmet, HelmetProps } from 'react-helmet';

export interface SeoProps extends HelmetProps {
  title: string;
}

function Seo(props: SeoProps) {
  const { title, children, ...otherProps } = props;
  return (
    <Helmet {...otherProps}>
      <title>{`${process.env.REACT_APP_SITE_TITLE} - ${title}`}</title>
      {children}
    </Helmet>
  );
}
export default Seo;
